import { render, staticRenderFns } from "./redirection_login.vue?vue&type=template&id=5265d4eb&"
import script from "./redirection_login.vue?vue&type=script&lang=js&"
export * from "./redirection_login.vue?vue&type=script&lang=js&"
import style0 from "./redirection_login.vue?vue&type=style&index=0&id=5265d4eb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports